export default "__VITE_ASSET__nqifXfN8__"